import { render } from "./CheckboxGeneric.vue?vue&type=template&id=02e7af65"
import script from "./CheckboxGeneric.vue?vue&type=script&lang=ts"
export * from "./CheckboxGeneric.vue?vue&type=script&lang=ts"
script.render = render

export default script